// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3k0jE","type":"styles_type__2Drdd","choices":"styles_choices__g-vZ4"};